"use client";
import { jsxs as t, jsx as a } from "react/jsx-runtime";
const n = ({
  title: c,
  titleId: l,
  desc: e,
  descId: i,
  ...r
}) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": l,
    "aria-describedby": i,
    ...r,
    children: [
      e ? /* @__PURE__ */ a("desc", { id: i, children: e }) : null,
      c ? /* @__PURE__ */ a("title", { id: l, children: c }) : null,
      /* @__PURE__ */ a("path", { d: "M22.434 12.776a6.442 6.442 0 0 0-6.435-6.434 6.442 6.442 0 0 0-6.435 6.434A6.442 6.442 0 0 0 16 19.211a6.442 6.442 0 0 0 6.435-6.435Zm-6.435 5.005a5.01 5.01 0 0 1-5.005-5.005A5.01 5.01 0 0 1 16 7.772a5.01 5.01 0 0 1 5.005 5.004A5.01 5.01 0 0 1 16 17.781Z" }),
      /* @__PURE__ */ a("path", { d: "M16 9.201a3.579 3.579 0 0 0-3.576 3.575A3.579 3.579 0 0 0 16 16.351a3.579 3.579 0 0 0 3.575-3.575A3.579 3.579 0 0 0 16 9.201m0 5.72a2.147 2.147 0 0 1-2.146-2.145c0-1.183.962-2.145 2.145-2.145s2.145.962 2.145 2.145a2.147 2.147 0 0 1-2.145 2.145Z" }),
      /* @__PURE__ */ a("path", { d: "m27.14 26.015-2.67-6.088a3.49 3.49 0 0 0 .457-2.268c-.111-.776.21-1.55.843-2.024 1.88-1.409 1.863-4.322-.007-5.724a2.143 2.143 0 0 1-.836-2.02c.33-2.305-1.744-4.381-4.045-4.044a2.151 2.151 0 0 1-2.024-.843c-1.41-1.881-4.32-1.866-5.724.007a2.133 2.133 0 0 1-2.02.836C8.792 3.503 6.74 5.58 7.072 7.89a2.15 2.15 0 0 1-.844 2.025c-1.874 1.405-1.857 4.325.007 5.724.627.47.947 1.243.836 2.02a3.48 3.48 0 0 0 .457 2.267l-2.67 6.088c-.237.543.299 1.141.864.971l3.618-1.1 1.64 3.405c.26.541 1.059.525 1.3-.023l2.438-5.567a3.656 3.656 0 0 0 2.562-.002l2.44 5.568c.238.544 1.041.558 1.3.024l1.64-3.404 3.618 1.1c.556.169 1.109-.41.863-.972ZM11.593 27.27l-1.232-2.556a.714.714 0 0 0-.852-.373l-2.718.825 1.794-4.09c.71.502 1.598.76 2.53.627.775-.11 1.55.21 2.024.844.107.142.237.252.36.373zm2.685-5.588a3.614 3.614 0 0 0-3.365-1.394c-1.38.197-2.624-1.05-2.427-2.426a3.576 3.576 0 0 0-1.4-3.372c-1.133-.849-1.12-2.59.006-3.435a3.575 3.575 0 0 0 1.394-3.366c-.2-1.398 1.038-2.614 2.426-2.427a3.57 3.57 0 0 0 3.371-1.4c.848-1.13 2.593-1.117 3.436.006a3.576 3.576 0 0 0 3.366 1.395c1.379-.196 2.623 1.05 2.427 2.426a3.577 3.577 0 0 0 1.4 3.37c1.112.835 1.12 2.592-.007 3.437a3.573 3.573 0 0 0-1.394 3.365c.2 1.396-1.032 2.626-2.426 2.427a3.569 3.569 0 0 0-3.371 1.4c-.85 1.133-2.59 1.122-3.436-.006m8.21 2.659a.714.714 0 0 0-.851.373l-1.232 2.556-1.906-4.351c.124-.122.256-.235.364-.38a2.139 2.139 0 0 1 2.02-.835 3.49 3.49 0 0 0 2.531-.625l1.792 4.087-2.717-.825Z" })
    ]
  }
);
export {
  n as default
};
